import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

const element : HTMLElement = document.getElementById('cookiebanner') as HTMLElement;

ReactDOM.render(
  <React.StrictMode>
    <App homePageId={element.getAttribute("data-homepage") ?? ""} />
  </React.StrictMode>,
  element
);
